import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/utility.guard";
import { SecureBlockchainAuthoringToolsComponent } from "./authoring-tools/secure-blockchain-authoring-tools.component";
import { DashboardComponent } from "./authoring-tools/dashboard/dashboard.component";

// Identity
import { IdentitySearchComponent } from "./authoring-tools/Identity-management/identity-search/identity-search.component";
import { IdentityCreateOrUpdateComponent } from "./authoring-tools/Identity-management/identity-create-or-update/identity-create-or-update.component";

// Smart Contract Management
import { SmartContractManagementSearchComponent } from "./authoring-tools/smart-contract-management/smart-contract-management-search/smart-contract-management-search.component";
import { SmartContractManagementCreateOrUpdateComponent } from "./authoring-tools/smart-contract-management/smart-contract-management-create-or-update/smart-contract-management-create-or-update.component";

// Operation
import { SmartContractOperationSearchComponent } from "./authoring-tools/smart-contract-operation/smart-contract-operation-search/smart-contract-operation-search.component";
import { SmartContractOperationSubmitComponent } from "./authoring-tools/smart-contract-operation/smart-contract-operation-submit/smart-contract-operation-submit.component";

// View
import { SmartContractViewSearchComponent } from "./authoring-tools/smart-contract-view/smart-contract-view-search/smart-contract-view-search.component";
import { SmartContractViewKeysComponent } from "./authoring-tools/smart-contract-view/smart-contract-view-keys/smart-contract-view-keys.component";
import { SmartContractViewHistoryComponent } from "./authoring-tools/smart-contract-view/smart-contract-view-history/smart-contract-view-history.component";
import { SmartContractAccessFlowSearchComponent } from "./authoring-tools/smart-contract-access-flow/smart-contract-access-flow-search/smart-contract-access-flow-search.component";


export const secureBlockchainRoutes: Routes = [
    {
        path: "secure-blockchain/auth-tools",
        component: SecureBlockchainAuthoringToolsComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [

            //  Dashboard
            {
                path: "",
                component: DashboardComponent
            },

            {
                path: "access-flow/search",
                component: SmartContractAccessFlowSearchComponent
            },

            // =========================
            //  Identity Management
            // =========================
            {
                path: "identity/search",
                component: IdentitySearchComponent
            },
            {
                path: "identity/create",
                component: IdentityCreateOrUpdateComponent,
                data: { create: true }
            },
            {
                path: "identity/update/:id",
                component: IdentityCreateOrUpdateComponent,
                data: { create: false }
            },

            // =========================
            //  Smart Contract Management
            // =========================
            {
                path: "smart-contract/search",
                component: SmartContractManagementSearchComponent
            },
            {
                path: "smart-contract/create",
                component: SmartContractManagementCreateOrUpdateComponent,
                data: { create: true }
            },
            {
                path: "smart-contract/update/:id",
                component: SmartContractManagementCreateOrUpdateComponent,
                data: { create: false }
            },

            // =========================
            //  Smart Contract Operation
            // =========================
            {
                path: "operation/search",
                component: SmartContractOperationSearchComponent
            },
            {
                path: "operation/submit/:id",
                component: SmartContractOperationSubmitComponent
            },

            // =========================
            //  Smart Contract View
            // =========================
            {
                path: "view/search",
                component: SmartContractViewSearchComponent
            },
            {
                path: "view/:id/:key",
                component: SmartContractViewHistoryComponent
            },
            {
                path: "view/:id",
                component: SmartContractViewKeysComponent
            }
            
        ]
    }
];

export const secureBlockchainRouter = RouterModule.forChild(secureBlockchainRoutes);